import React from 'react';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import { groupBy } from 'ramda';
import { Grid, Cell } from '../grid';
import { CtaButton } from '../styled';

const JobListingsSectionContainer = styled.div`
  max-width: 990px;
  margin: 0 auto;
  font-size: 20px;
  line-height: 24px;
  padding: 0 25px;
`;

const JobDepartmentSection = styled.div`
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
  margin-bottom: 40px;
`;

const DepartmentName = styled.div`
  padding-top: 28px;
`;

const Job = styled.div`
  box-sizing: border-box;
  height: 98px;
  padding: 28px 0;
`;

const JobRole = styled.div`
  flex: 1;
  font-weight: 600;
  line-height: 21px;
`;

const JobDetails = styled.div`
  color: #999999;
  font-size: 14px;
  line-height: 21px;
  text-transform: uppercase;
  margin-top: 8px;
`;

const JobButtonContainer = styled.div`
  text-align: right;
`;

const ApplyButton = styled(CtaButton)`
  background: #1e5cb3;
  color: white;
  line-height: 45px;
  width: 96px;

  &:hover {
    background: #3f81df;
  }

  &:active {
    background: #133a71;
  }
`;

const ResumeButton = styled(ApplyButton)`
  box-sizing: border-box;
  background: rgba(30, 92, 179, 0.2);
  color: #1e5cb3;
  width: 180px;
  height: auto;


  &:hover {
    background: rgba(63, 129, 223, 0.2);
  }

  &:active {
    background: rgba(19, 58, 113, 0.2);
  }

  @media (max-width: 580px) {
    padding: 8px 22px;
    max-width: 180px;
    width: auto;
    line-height: 18px;
  }
`;

const ResponsiveCell = styled(Cell)`
  @media (max-width: 767px) {
    display: none;
  }
`;

function JobListingsSection({ input }) {
  const allLeverRes = useStaticQuery(graphql`
    {
      allLever {
        edges {
          node {
            id
            lever_id
            createdAt
            text
            hostedUrl
            applyUrl
            categories {
              commitment
              location
              team
            }
            description
            descriptionPlain
            lists {
              text
              content
            }
            additional
            additionalPlain
          }
        }
      }
    }
  `);

  const leverEdges = allLeverRes.allLever.edges;

  const jobsByDeparment = groupBy((leverEdge) => {
    return leverEdge.node.categories.team;
  }, leverEdges);

  return (
    <JobListingsSectionContainer>
      {Object.keys(jobsByDeparment).map((department, index) => {
        return (
          <JobDepartmentSection key={index}>
            <Grid columns={12}>
              <Cell xs={12} sm={3}>
                <DepartmentName>{department}</DepartmentName>
              </Cell>
              <Cell xs={12} sm={9}>
                {jobsByDeparment[department].map((job, i) => {
                  return (
                    <Job key={i}>
                      <Grid columns={12}>
                        <Cell xs={9}>
                          <JobRole>{job.node.text}</JobRole>
                          <JobDetails>{job.node.categories.commitment} &#183; {job.node.categories.location}</JobDetails>
                        </Cell>
                        <Cell xs={3}>
                          <JobButtonContainer>
                            {/* <a href={job.node.hostedUrl} target="_blank" rel="noopener noreferrer">
                              <ApplyButton type="button">Apply</ApplyButton>
                            </a> */}
                            <a href="mailto: support@trueusd.com">
                              <ApplyButton type="button">Apply</ApplyButton>
                            </a>
                          </JobButtonContainer>
                        </Cell>
                      </Grid>
                    </Job>
                  );
                })}
              </Cell>
            </Grid>
          </JobDepartmentSection>
        );
      })}
      <Grid columns={12}>
        <ResponsiveCell xs={9} sm={3}>&nbsp;</ResponsiveCell>
        <Cell xs={12} sm={9}>
          <Job>
            <Grid columns={12}>
              <Cell xs={8}>
                <JobRole>{input.primary.question.text}</JobRole>
                <JobDetails>{input.primary.description.text}</JobDetails>
              </Cell>
              <Cell xs={4}>
                <JobButtonContainer>
                  {/* <a href="https://jobs.lever.co/trusttoken/6734faac-dbee-406a-96b8-17da9f5edec6" target="_blank" rel="noopener noreferrer">
                    <ResumeButton type="button">{input.primary.button_label.text}</ResumeButton>
                  </a> */}
                  <a href="mailto: support@trueusd.com">
                    <ResumeButton type="button">{input.primary.button_label.text}</ResumeButton>
                  </a>
                </JobButtonContainer>
              </Cell>
            </Grid>
          </Job>
        </Cell>
      </Grid>
    </JobListingsSectionContainer>
  );
}

export { JobListingsSection };
